import { Properties } from './pinch-to-zoom.interfaces';

export const defaultProperties: Properties = {
	transitionDuration: 200,
	limitZoom: 'original image size',
	autoZoomOut: false,
	disabled: false,
	overflow: 'hidden',
	backgroundColor: 'rgb(255,255,255)',
	minPanScale: 1.0001,
	minScale: 0
	// draggableImage: true,
};

export const backwardCompatibilityProperties = {
	'transition-duration': 'transitionDuration',
	'auto-zoom-out': 'autoZoomOut',
	'limit-zoom': 'limitZoom'
};
